var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileShield02 = function SvgFileShield02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 4v6.183-.03V20zm2.25 9.75h3.473a6.013 6.013 0 0 1 1.085-1.5H7.25zm0 4h2.767a5 5 0 0 1-.056-.745q0-.37.047-.755H7.25zM5.308 21.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V4.308q0-.758.525-1.283T5.308 2.5h7.942l5.25 5.25v2.675l-1.5-.242V8.5h-4.5V4H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v15.384q0 .116.096.212a.3.3 0 0 0 .212.096h5.454q.216.43.488.806.27.375.606.694z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.5 22q-1.737-.437-2.869-1.99a5.73 5.73 0 0 1-1.131-3.45v-3.057l4-1.503 4 1.503v3.056a5.73 5.73 0 0 1-1.131 3.45Q18.239 21.564 16.5 22m0-1.437q1.158-.392 1.92-1.5a4.26 4.26 0 0 0 .763-2.47v-2.125l-2.683-1.01-2.683 1.011v2.123q0 1.36.762 2.47.763 1.11 1.921 1.5"
  })));
};
export default SvgFileShield02;